import { ApiResponse } from "@/types/apis";
import request from "@/utils/request";

/**
 * 获取成本中心列表
 */
export const getCostCenter = (fdFactory: string) =>
  request.get<ApiResponse<CostCenterListItem[]>>("/sap/getCostCenter", {
    params: {
      fdFactory,
    },
  });

interface CostCenterListItem {
  /**
   * 实际值
   */
  f101: string;
  /**
   * 显示值
   */
  f102: string;
}
